import React from 'react'

const NotFound = () => (<h1 className="Error_Text">Error: 404 Page Not Found</h1>   )

export default NotFound